import React from "react";
import exportDocs from '../utils/exportDocs'

const Instructions = ({ messages }) => {
  return (
    <div className="flex-1 bg-gray-500 text-center mr-2 h-auto">
      <h1 className="text-white ">Instructions</h1>
      <ol className="text-white text-left list-inside mx-4 list-decimal">
        <li>Add participants in the participant list</li>
        <li>Use tab key to cycle by ascending order of participant</li>
        <li>Use shift + tab to cycle in reverse order</li>
      </ol>
      <div className='mt-2'>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded inline-flex mx-4 justify-center w-auto shadow-xl"
          onClick={() => exportDocs(messages)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <span>Download as Word Doc</span>
        </button>
      </div>
    </div>
  );
};

export default Instructions;
